export default "__VITE_ASSET__OwoyJFN7__"